module.exports = "https://venezia-network.servercdn.it/static/fonts/FuturaPT-Book.ttf?0d987efe9bc0b858a7bc0367c2d5922c";